/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class FindIdResult extends Component {
  _login = () => {
    const { history } = this.props;
    history.push("/login");
  };
  _goBack = () => {
    // const { history } = this.props;
    const { onFindIdCode } = this.props.childProps;
    onFindIdCode(100, "", 0);
    //history.goBack()
  };
  render() {
    const { findIdCode, findId } = this.props.childProps;
    return (
      <Fragment>
        <div className="login_content width4">
          {findIdCode === 0 ? (
            <div className="login_padding">
              <h1>아이디 찾기 성공</h1>
              <div className="login_end">
                회원님이 찾으신 아이디는 <span>{findId}</span>입니다.
                <br />
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._login}>
                  로그인
                </a>
              </div>
            </div>
          ) : findIdCode === 4 ? (
            <div className="login_padding">
              <h1>탈퇴한 회원 계정</h1>
              <div className="login_end">
                회원님이 찾으신 아이디는 이미 탈퇴한 계정입니다.
                <br />
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._goBack}>
                  확인
                </a>
              </div>
            </div>
          ) : findIdCode === -1 ? (
            <div className="login_padding">
              <h1>일치 회원 계정</h1>
              <div className="login_end">
                일치하는 사용자 계정을 찾을 수 없습니다.
                <br />
                <br />
                아이디를 찾을 수 없는 경우,
                <br />
                <a href="#">고객센터</a>로 연락해 주세요.
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._goBack}>
                  확인
                </a>
              </div>
            </div>
          ) : (
            <div className="login_padding">
              <h1>오류</h1>
              <div className="login_end">
                잘못된 경로 또는 알수 없는 오류입니다.
                <br />
                <br />
                계속 같은 현상이 발생하면,
                <br />
                <a href="#">고객센터</a>로 연락해 주세요.
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._goBack}>
                  확인
                </a>
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(FindIdResult));
